import { render, staticRenderFns } from "./AppSortButton.vue?vue&type=template&id=72beb045&scoped=true&"
import script from "./AppSortButton.vue?vue&type=script&lang=ts&"
export * from "./AppSortButton.vue?vue&type=script&lang=ts&"
import style0 from "./AppSortButton.vue?vue&type=style&index=0&id=72beb045&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72beb045",
  null
  
)

export default component.exports